import React from "react"
import Art from "./components/Art"
import Header from "./components/Header"

function App(){
  return (
    <div className="App">
      <Header/>
      <Art/>
    </div>
  )
}

export default App
